/**
 * Artikeltext von Hand bearbeiten, ohne HTML zu tippen (Korrektur je Artikel, 28.09.2026).
 *
 * Schreibweise im Textfeld:
 *   # Überschrift        → fett + unterstrichen (wie „Im Überblick")
 *   - Punkt              → Listenpunkt
 *   leere Zeile          → neuer Absatz
 *
 * Das erzeugte HTML folgt dem gemessenen Gerüst aus `texte/bausteine.ts` (Backend), damit
 * ein von Hand geänderter Text im Shop genauso aussieht wie ein gerechneter.
 */

const escape = (s: string) => s
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

export type Block = { art: 'titel' | 'absatz' | 'liste'; zeilen: string[] };

/** Textfeld → Blöcke. Pure. */
export function textZuBloecken(text: string): Block[] {
  const bloecke: Block[] = [];
  let absatz: string[] = [];
  const schliesseAbsatz = () => {
    if (absatz.length > 0) bloecke.push({ art: 'absatz', zeilen: [absatz.join(' ')] });
    absatz = [];
  };
  for (const roh of String(text ?? '').split(/\r?\n/)) {
    const zeile = roh.trim();
    if (!zeile) { schliesseAbsatz(); continue; }
    if (zeile.startsWith('#')) {
      schliesseAbsatz();
      const t = zeile.replace(/^#+\s*/, '');
      if (t) bloecke.push({ art: 'titel', zeilen: [t] });
      continue;
    }
    if (/^[-•*]\s+/.test(zeile)) {
      schliesseAbsatz();
      const punkt = zeile.replace(/^[-•*]\s+/, '');
      const letzter = bloecke[bloecke.length - 1];
      if (letzter?.art === 'liste') letzter.zeilen.push(punkt);
      else bloecke.push({ art: 'liste', zeilen: [punkt] });
      continue;
    }
    absatz.push(zeile);
  }
  schliesseAbsatz();
  return bloecke;
}

/** Blöcke → HTML im Shop-Gerüst. Pure. */
export function bloeckeZuHtml(bloecke: Block[]): string {
  return bloecke.map(b => {
    if (b.art === 'titel') {
      return `<p style="margin-bottom:11px"><span style="font-size:14px;"><b><u>${escape(b.zeilen[0])}</u></b></span></p>`;
    }
    if (b.art === 'liste') {
      return `<ul>${b.zeilen.map(z => `<li style="margin-left:8px">${escape(z)}</li>`).join('')}</ul>`;
    }
    return `<p>${escape(b.zeilen[0])}</p>`;
  }).join('');
}

/** Blöcke → Textfeld. Pure. */
export function bloeckeZuText(bloecke: Block[]): string {
  return bloecke.map(b => b.art === 'titel' ? `# ${b.zeilen[0]}`
    : b.art === 'liste' ? b.zeilen.map(z => `- ${z}`).join('\n')
    : b.zeilen[0]).join('\n\n');
}
